module.exports = __webpack_public_path__ + "static/media/ms.b6ab5819.svg";